var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTelecom(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "128.000000pt",
    height: "128.000000pt",
    viewBox: "0,0,256,256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#0073c2",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.03093,0.05577) scale(2,2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,128) scale(0.1,-0.1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M214,1243c-50,-53 -95,-151 -107,-236c-14,-97 8,-204 58,-287c63,-103 121,-132 148,-73c9,19 7,28 -11,51c-125,156 -133,308 -26,463c46,67 46,69 30,94c-23,35 -51,31 -92,-12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M974,1254c-17,-24 -16,-26 15,-67c17,-23 43,-67 59,-97c23,-47 27,-67 27,-140c0,-76 -3,-92 -33,-150c-17,-36 -43,-80 -56,-98c-28,-38 -23,-70 13,-83c54,-21 153,128 174,260c19,127 -24,276 -106,364c-41,43 -70,47 -93,11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367,1143c-45,-48 -71,-120 -70,-198c0,-76 16,-124 58,-180c31,-40 56,-50 85,-35c27,15 25,51 -5,96c-54,79 -55,161 -4,236c31,46 36,77 17,96c-20,20 -53,14 -81,-15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M832,1158c-19,-19 -14,-50 18,-96c51,-77 49,-164 -6,-239c-32,-42 -31,-80 1,-95c36,-16 72,12 110,87c38,75 41,173 6,250c-39,87 -95,127 -129,93z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M596,1090c-56,-17 -106,-85 -106,-145c0,-34 35,-102 60,-115c19,-10 9,-32 -170,-390c-105,-209 -190,-386 -190,-393c0,-24 37,-50 62,-44c17,5 35,30 68,97l44,90h276h276l39,-80c47,-96 65,-115 99,-106c54,14 48,33 -152,432l-189,379l33,32c56,55 57,136 3,198c-17,19 -47,39 -67,45c-42,11 -47,11 -86,0zM671,981c20,-16 22,-23 14,-47c-9,-24 -16,-29 -45,-29c-29,0 -36,5 -45,29c-8,24 -6,31 14,47c13,10 27,19 31,19c4,0 18,-9 31,-19zM688,645c23,-47 42,-87 42,-90c0,-3 -40,-5 -90,-5c-49,0 -90,2 -90,5c0,10 85,175 90,175c3,0 25,-38 48,-85zM823,375c20,-42 37,-78 37,-80c0,-3 -99,-5 -220,-5c-121,0 -220,2 -220,5c0,2 17,38 37,80l37,75h146h146z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelecom);
export default __webpack_public_path__ + "static/media/telecom.0db0a9d31358d7416c5a8b0f472233b0.svg";
export { ForwardRef as ReactComponent };